import React from "react";

/**
 * Spam trap for public forms. Invisible to people (and screen readers); bots that fill every
 * field set `website`, and the API silently drops those submissions.
 */
export default function Honeypot({ value, onChange }) {
    return (
        <div aria-hidden="true" style={{ position: "absolute", left: "-10000px", width: 1, height: 1, overflow: "hidden" }}>
            <label htmlFor="hp-website">Website</label>
            <input id="hp-website" name="website" type="text" tabIndex={-1} autoComplete="off"
                value={value} onChange={(e) => onChange(e.target.value)} />
        </div>
    );
}
